import { load } from '@ms/yammer-data/dist/domains/featureAccessSettings/actions';
import type { ThunkDispatch } from '@ms/yammer-data/dist/types';
import { getFeatureAccessSettingsApiCaching } from 'domains/teams/apiCaching';
import { getHostClientType } from 'state/teamsContext/selectors';
import type { YammerTeamsNativeState } from 'state/types';

type LoadFeatureAccessSettings = (
  dispatch: ThunkDispatch<YammerTeamsNativeState>,
  getState: () => YammerTeamsNativeState
) => Promise<void>;
export const loadFeatureAccessSettings: LoadFeatureAccessSettings = async (dispatch) => {
  const hostClientType = getHostClientType();
  const caching = getFeatureAccessSettingsApiCaching('ReadCacheOrFetchAndWrite', hostClientType);

  await dispatch(load({ initiator: 'bootstrap_async', caching }));
};
